module.exports = __webpack_public_path__ + "filter-members.svg?352901b4b4ea179d43610d79017e71b6";